import { FILTER } from "@/constants";
import CheckboxSelect from "@/containers/Filters/CheckboxSelect";
import FilterCountIndicator from "@/containers/Filters/FilterCountIndicator";
import useFilterCount from "@/containers/Filters/hooks/useFilterCount";
import { FilterOption } from "@/types/FilterOptions";
import { Accordion } from "@components/Accordion";

import useOptionLabel from "../../hooks/useOptionLabel";

export type SentimentProps = {
  options: FilterOption[];
};

const Sentiment: React.FunctionComponent<SentimentProps> = ({ options }) => {
  const preview = useOptionLabel(FILTER.SENTIMENT, options);
  const count = useFilterCount(FILTER.SENTIMENT);

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <Accordion
      value="sentiment"
      title={L.MENTIONS_VIEW_TOOLBAR_FILTER_SENTIMENT_LABEL}
      preview={preview}
      indicator={<FilterCountIndicator count={count} />}
    >
      <CheckboxSelect
        data-testid="filter-bar--sentiment"
        name={FILTER.SENTIMENT}
        options={options}
      />
    </Accordion>
  );
};

export default Sentiment;
